import type React from 'react'
import type { IconProps } from './types'

const ChevRightIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M8.42 20L7 18.58L13.58 12L7 5.42L8.42 4L16.42 12L8.42 20Z' />
	</svg>
)

export default ChevRightIcon
